import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledDownloadPdfIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5859 1.5C14.9837 1.50004 15.3652 1.65818 15.6465 1.93945L19.0605 5.35352C19.3418 5.63479 19.5 6.01629 19.5 6.41406V20C19.5 21.3807 18.3807 22.5 17 22.5H7C5.61929 22.5 4.5 21.3807 4.5 20V4C4.5 2.61929 5.61929 1.5 7 1.5H14.5859Z",
			fill: "white",
			stroke: "#007AAF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 5.5L15.5 2.5V5.5H18.5Z",
			fill: "#4BBFDA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 2V5C15 5.55228 15.4477 6 16 6H19",
			stroke: "#007AAF",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 4.5,
			fill: "white",
			stroke: "#007AAF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 21.1213L21.1213 19",
			stroke: "#007AAF",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 17V21",
			stroke: "#007AAF",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 21.1213L16.8787 19",
			stroke: "#007AAF",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.9304 14V9.63636H8.56676C8.90199 9.63636 9.18324 9.69886 9.41051 9.82386C9.6392 9.94886 9.81179 10.1207 9.92827 10.3395C10.0462 10.5568 10.1051 10.804 10.1051 11.081C10.1051 11.3608 10.0462 11.6094 9.92827 11.8267C9.81037 12.044 9.63636 12.2152 9.40625 12.3402C9.17614 12.4638 8.89276 12.5256 8.55611 12.5256H7.47159V11.8757H8.44957C8.6456 11.8757 8.80611 11.8416 8.93111 11.7734C9.05611 11.7053 9.14844 11.6115 9.2081 11.4922C9.26918 11.3729 9.29972 11.2358 9.29972 11.081C9.29972 10.9261 9.26918 10.7898 9.2081 10.6719C9.14844 10.554 9.0554 10.4624 8.92898 10.397C8.80398 10.3303 8.64276 10.2969 8.44531 10.2969H7.72088V14H6.9304ZM12.0204 14H10.5417V9.63636H12.0502C12.4835 9.63636 12.8556 9.72372 13.1667 9.89844C13.4792 10.0717 13.7193 10.321 13.8869 10.6463C14.0545 10.9716 14.1383 11.3608 14.1383 11.8139C14.1383 12.2685 14.0538 12.6591 13.8848 12.9858C13.7172 13.3125 13.475 13.5632 13.1582 13.7379C12.8429 13.9126 12.4636 14 12.0204 14ZM11.3322 13.3161H11.9821C12.286 13.3161 12.5396 13.2607 12.7427 13.1499C12.9458 13.0376 13.0985 12.8707 13.2008 12.6491C13.3031 12.4261 13.3542 12.1477 13.3542 11.8139C13.3542 11.4801 13.3031 11.2031 13.2008 10.983C13.0985 10.7614 12.9473 10.5959 12.747 10.4865C12.5481 10.3757 12.301 10.3203 12.0055 10.3203H11.3322V13.3161ZM14.6394 14V9.63636H17.4348V10.299H15.4299V11.4837H17.2431V12.1463H15.4299V14H14.6394Z",
			fill: "#0080A3"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledDownloadPdfIcon);
const Memo = memo(ForwardRef);
export default Memo;
